import React, { useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, usePermissions } from '../../hooks/useAuth';
import LoadingScreen from '../common/LoadingScreen';
import toast from 'react-hot-toast';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { loading, isAuthenticated } = useAuth();
  const { isAdmin } = usePermissions();
  const location = useLocation();
  const hasShownToast = useRef(false);

  // Show loading while checking authentication
  if (loading) {
    return <LoadingScreen message="Checking authentication..." />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return (
      <Navigate
        to="/login"
        state={{ from: location }}
        replace
      />
    );
  }

  // Check if user is admin
  if (!isAdmin()) {
    // Show error only once per session
    if (!hasShownToast.current) {
      hasShownToast.current = true;
      toast.error('Access denied. Admin privileges required.');
    }
    return (
      <Navigate
        to="/dashboard"
        replace
      />
    );
  }

  // User is authenticated and is admin
  return <>{children}</>;
};

export default AdminRoute;
